document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".select-color-dropdown").forEach((select) => {
    const preview = select
      .closest(".select-product-color")
      .querySelector(".swatch-preview");
    if (!preview) return;
    select.addEventListener("change", () => {
      const img = select.selectedOptions[0].dataset.image;
      if (img) preview.src = img;
    });
  });

  document.querySelectorAll(".custom-select").forEach((wrapper) => {
    const trigger = wrapper.querySelector(".custom-select__trigger");
    const options = wrapper.querySelector(".custom-options");
    const hiddenInput = wrapper.parentElement.querySelector(
      'input[type="hidden"]'
    );
    if (!trigger || !options || !hiddenInput) return;

    trigger.addEventListener("click", (evt) => {
      evt.preventDefault();
      options.style.display =
        options.style.display === "flex" ? "none" : "flex";
    });

    wrapper.querySelectorAll(".custom-option").forEach((option) => {
      option.addEventListener("click", (evt) => {
        evt.preventDefault();
        wrapper
          .querySelector(".custom-option.selected")
          ?.classList.remove("selected");
        option.classList.add("selected");
        trigger.querySelector(".custom-select__option-content").innerHTML =
          option.innerHTML;
        options.style.display = "none";
        hiddenInput.value = option.dataset.value;
      });
    });

    document.addEventListener("click", (e) => {
      if (!wrapper.contains(e.target)) {
        options.style.display = "none";
      }
    });
  });

  const $variantPicker = document.querySelector("variant-picker");
  const $firstBuySheet = document.querySelector(".offer-product-item");
  const $priceGroupWrapper = document.querySelector(
    ".product-block-group--price"
  );

  const updatePrices = () => {
    setTimeout(() => {
      $firstBuySheet.querySelector(".offer-badges-discount").innerText =
        $priceGroupWrapper.querySelector(".m-currency--saved")?.innerText || "";

      $firstBuySheet.querySelector(".current-price").innerText =
        $priceGroupWrapper.querySelector(".m-price-item--sale")?.innerText ||
        "";

      $firstBuySheet.querySelector(".product-item-regular-price").innerText =
        $priceGroupWrapper.querySelector(".m-price-item--regular")?.innerText ||
        "";
    }, 100);
  };

  $variantPicker.addEventListener("click", updatePrices);
  $variantPicker.addEventListener("change", updatePrices);

  const $atcButton = document.querySelector(".dtc-test-button");
  const $atcButtonOriginal = document.querySelector(".m-add-to-cart");
  const labelQtyOptions = [...document.querySelectorAll(".offer-product-item")];
  labelQtyOptions.forEach(label => {
  label.addEventListener('click', () => {
    const isIndexOne = label.dataset.index === '1';

    $atcButton.classList.toggle('dtc-hidden', isIndexOne);
    $atcButtonOriginal.classList.toggle('dtc-hidden', !isIndexOne);
  });
});

  $atcButton.addEventListener("click", function () {
    $atcButton.classList.add("m-spinner-loading");
    let activeLabel = labelQtyOptions.find((label) => {
      return label.querySelector("input").checked;
    });
    let selectedVariants = [...activeLabel.querySelectorAll("custom-variants")];
    const items = selectedVariants.map((variant) => {
      return {
        id: variant.dataset.currentVariant,
        quantity: 1,
      };
    });
    console.log(items);
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ items }),
    })
      .then((response) => {
        if (!response.ok) throw new Error("Error al agregar al carrito");
        $atcButton.classList.remove("m-spinner-loading");
        return response.json();
      })
      .then((data) => {
        const test = document.querySelector("m-cart-drawer");
        setTimeout(() => {
          test.open();
          test.onCartDrawerUpdate();
        }, 500);
        document.querySelector('.m-cart-count-bubble').classList.remove('m:hidden')
        console.log("Producto agregado:", data);
        // Aquí podrías mostrar una notificación o actualizar el UI
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  });
});
class VariantSelector extends HTMLElement {
  connectedCallback() {
    this.variants = JSON.parse(this.dataset.variant);

    this.colorOptions = [
      ...this.querySelectorAll(".custom-select-wrapper .custom-option"),
    ];
    this.sizeOptions = [...this.querySelectorAll(".select-size-dropdown")];
    this.discount = this.dataset.discount;

    this.colorOptions.forEach((color) => {
      color.addEventListener("click", () => {
        setTimeout(() => {
          this.handleOptionChange();
        }, 300);
      });
    });
    this.sizeOptions.forEach((size) => {
      size.addEventListener("change", () => {
        setTimeout(() => {
          this.handleOptionChange();
        }, 300);
      });
    });
  }
  chooseVariant({ option1, option2 }) {
    const matched =
      this.variants.find(
        (v) => v.option1 === option1 && (!v.option2 || v.option2 === option2)
      ) || {};
    return matched;
  }
  handleOptionChange() {
    let parentNode = this.closest(".offer-product-item");
    let selectedColorOptions = [
      ...parentNode.querySelectorAll(
        ".custom-select__option-content .title-options-value"
      ),
    ];
    let selectedSizeOptions = [
      ...parentNode.querySelectorAll(".select-size-dropdown"),
    ];
    let groupedVariants = selectedColorOptions.map((option, index) => {
      parentNode.querySelectorAll("custom-variants")[
        index
      ].dataset.currentVariant = this.chooseVariant({
        option1: option.innerText,
        option2: selectedSizeOptions[index].value,
      }).id;
      return {
        matched: this.chooseVariant({
          option1: option.innerText,
          option2: selectedSizeOptions[index].value,
        }),
      };
    });
    let { totalPrice, totalCompareAtPrice } = groupedVariants.reduce(
      (acc, variant) => {
        const price = Number(variant.matched.price) || 0;
        const compareAtPrice = Number(variant.matched.compare_at_price) || 0;

        acc.totalPrice += price;
        acc.totalCompareAtPrice += compareAtPrice;

        return acc;
      },
      { totalPrice: 0, totalCompareAtPrice: 0 }
    );

    let regularPriceSelector = parentNode.querySelector(".current-price");
    let compareAtPriceSelector = parentNode.querySelector(
      ".product-item-regular-price"
    );
    let parsedItemsTimes = parseInt(parentNode.querySelector('custom-variants').dataset.itemsTimes);
    console.log({element:parentNode.querySelector('custom-variants'), parsedElement: parseInt(parentNode.querySelector('custom-variants').dataset.itemsTimes )})
    regularPriceSelector.innerHTML = formatMoney(
      totalPrice/parsedItemsTimes,
      window.MinimogSettings.money_format
    );
    compareAtPriceSelector.innerHTML = formatMoney(
      totalCompareAtPrice/parsedItemsTimes,
      window.MinimogSettings.money_format
    );
  }
}
customElements.define("custom-variants", VariantSelector);
